import { __assign } from "tslib";
import { BasePopover } from './base-popover';
import * as React from 'react';
export var PrimaryPopover = function (props) {
    return React.createElement(BasePopover, __assign({}, props, { popoverType: 'primary' }), props.children);
};
export var Popover = PrimaryPopover;
export var SecondaryPopover = function (props) {
    return React.createElement(BasePopover, __assign({}, props, { popoverType: 'secondary' }), props.children);
};
var DarkPopover = function (props) {
    return React.createElement(BasePopover, __assign({}, props, { popoverType: 'dark' }), props.children);
};
export var CallDevicePopover = DarkPopover;
//# sourceMappingURL=popover.js.map